export default {"src":"/_next/static/media/gray-star.61f91a35.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};